<table class="tiime-table" aria-label="Tableau pièces jointes">
  <thead>
    <tr tiimeTableHeaderRow>
      @if (displayedColumns() | includes: 'name') {
        <th tiimeTableHeaderCell="name">Nom du fichier</th>
      }
      @if (displayedColumns() | includes: 'title') {
        <th class="align-column-with-input-value" tiimeTableHeaderCell="title">Titre</th>
      }
      @if (displayedColumns() | includes: 'type') {
        <th class="align-column-with-input-value" tiimeTableHeaderCell="type">Type</th>
      }
      @if (displayedColumns() | includes: 'contact') {
        <th class="align-column-with-input-value" tiimeTableHeaderCell="contact">Contact</th>
      }
      @if (displayedColumns() | includes: 'createdAtBy') {
        <th tiimeTableHeaderCell="createdAtBy"></th>
      }
      @if (displayedColumns() | includes: 'actions') {
        <th tiimeTableHeaderCell="actions"></th>
      }
    </tr>
  </thead>
  <tbody>
    @for (fileForm of filesForms; track i; let i = $index) {
      <tr tiimeTableRow [formGroup]="fileForm">
        @if (displayedColumns() | includes: 'name') {
          <td tiimeTableCell="name">
            @if (fileForm.type.value === MissionAcceptanceFileType.contractLdm && !fileForm.name.value) {
              <div
                class="import-in-progress"
                tiimeTooltip="L'intégration de la pièce jointe provenant d'un contrat est en cours"
              >
                <mat-icon>sync</mat-icon>
                Intégration en cours
              </div>
            } @else {
              <app-simple-cell [value]="fileForm.name.value"></app-simple-cell>
            }
          </td>
        }
        @if (displayedColumns() | includes: 'title') {
          <td tiimeTableCell="title">
            @if (fileForm.content.value) {
              <input type="text" placeholder="Titre" formControlName="title" />
            } @else {
              <app-simple-cell class="align-column-with-input-value" [value]="fileForm.title.value ?? 'Sans titre'" />
            }
          </td>
        }
        @if (displayedColumns() | includes: 'type') {
          <td class="visible-cell" tiimeTableCell="type">
            @if (fileForm.id.value) {
              <app-simple-cell
                class="align-column-with-input-value"
                [value]="fileForm.type.value | codeAndLabel: fileTypes()"
              />
            } @else {
              <tiime-select [formControl]="fileForm.type" placeholder="Type">
                <div tiimeSelectOptions>
                  @for (type of fileTypes(); track $index) {
                    <mat-option [value]="type.code">
                      {{ type.label }}
                    </mat-option>
                  }
                </div>
              </tiime-select>
              @if (fileForm.type.value === MissionAcceptanceFileType.identityPiece) {
                <mat-icon
                  fontSet="fontastic"
                  fontIcon="icon-ic-info"
                  tiimeTooltip
                  [tooltipContent]="identityPieceTooltipTemplate"
                ></mat-icon>
              }
            }
          </td>
        }
        @if (displayedColumns() | includes: 'contact') {
          <td tiimeTableCell="contact">
            @if (fileForm.id.value) {
              <app-simple-cell class="align-column-with-input-value" [value]="fileForm.contact.value?.fullName" />
            } @else {
              <app-user-select [selectData]="users()" [control]="fileForm.contact" label="" small />
            }
          </td>
        }
        @if (displayedColumns() | includes: 'createdAtBy') {
          <td tiimeTableCell="createdAtBy">
            @if (fileForm.createdAt?.value) {
              <mat-icon
                inline="true"
                fontSet="fontastic"
                fontIcon="icon-ic-info-2"
                [tiimeTooltip]="
                  'Ajouté le'
                    | atBy
                      : fileForm.createdAt?.value
                      : fileForm.createdBy?.value?.fullName ?? 'Système'
                      : 'DD/MM/YYYY à HH:mm'
                      : true
                "
              ></mat-icon>
            }
          </td>
        }
        @if (displayedColumns() | includes: 'actions') {
          <td class="show-on-hover" tiimeTableCell="actions">
            @if (fileForm.type.value !== MissionAcceptanceFileType.contractLdm || fileForm.name.value) {
              <button
                type="button"
                tiime-button
                color="primary"
                tabindex="-1"
                icon
                [disabled]="!fileForm.id.value"
                [tiimeTooltip]="
                  !fileForm.id.value
                    ? 'Veuillez enregistrer pour pouvoir télécharger la pièce jointe'
                    : 'Télécharger la pièce jointe'
                "
                (click)="emitDownloadFile(fileForm.id.value)"
              >
                <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-download-24"></mat-icon>
              </button>
              <button
                type="button"
                tiime-button
                color="primary"
                tabindex="-1"
                icon
                [disabled]="!fileForm.id.value"
                [tiimeTooltip]="
                  !fileForm.id.value
                    ? 'Veuillez enregistrer pour pouvoir ouvrir la pièce jointe dans un nouvel onglet'
                    : 'Ouvrir la pièce jointe dans un nouvel onglet'
                "
                (click)="emitOpenFileInNewTab(fileForm.id.value)"
              >
                <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
              </button>
            }
            <button
              type="button"
              tiime-button
              icon
              color="primary"
              tabindex="-1"
              tiimeTooltip="Retirer la pièce jointe"
              [disabled]="fileForm.disabled || fileForm.disabled"
              (click)="emitRemoveFile(fileForm.uniqId)"
            >
              <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
            </button>
          </td>
        }
      </tr>
    }
  </tbody>
</table>

<ng-template #identityPieceTooltipTemplate>
  <div class="tiime-tooltip-content">
    Critères de conformité :
    <ul>
      <li>Le document doit être recto/verso, en couleur et non photocopié (R/V sur un seul fichier).</li>
      <li>La bordure transparente doit être totalement apparente.</li>
      <li>L’ID doit être complètement lisible, sans aucun reflet.</li>
      <li>Un document de renouvellement ne peut remplacer une carte d’identité expirée.</li>
    </ul>
  </div>
</ng-template>
